import React from 'react';
import { connect } from 'react-redux';
import {Helmet} from "react-helmet";
import  PageHeader  from './PageHeader';
import  NavBarMultiPage      from "../components/common/NavBarMultiPage";
import  VisibilityWrapper      from "../components/common/VisibilityWrapper";
import  LoginForm   from './LoginForm';
import { startLogin } from '../actions/auth'; 
// import { FooterSection } from './FooterSection'; 
import Footer from "../components/common/Footer";
import { clearAuthError } from '../actions/auth';
// import { GoogleAdInit } from './advertisement/GoogleAdInit';
import  getAppConfigParm  from '../config/AppConfig';
import { displayAd } from './advertisements/helpers/displayAd';

// import LoadingPage from './LoadingPage';


// This LoginPage is the top level component. It renders the PageHeader and Login Form.
// This component passes its onSubmit method down to the LoginForm child component.
// It delegates the data entry and form data validation to the form itself. Once the
// form has validated the data, it will pass the form data up to this component by calling
// the onSubmit method passed down as a function prop. That form data will be used to dispatch
// the startLogin action. The startLogin action will log in the user, and update redux store 
// with user firstname, email, token, and isAuthenticated flag. When action successfully completes, 
// the user will be routed to the '/dashboard'. If login fails, the auth.error property 
// will be updated on the redux store and component will re-render with error message on top of form.
export class LoginPage extends React.Component { 

    onSubmit = (formData = {}) => {
        this.props.startLogin(formData);
    };

    componentDidMount = () => {
        if (this.props.auth.error) {
            this.props.clearAuthError();
        }
        // console.log("showAdd is   ", getAppConfigParm("showAd"))
    }

    /* This function adjusts the view port height based on whether Ads are displayed or not. The function
       returns an object with the height property */
    getPageContainerStyle = () => {
        return getAppConfigParm("showAd") ? { height: '70vh' } :  { height: '80vh' }
    }
     
    // Render login page and pass onSubmit function above, as function prop, to LoginForm. This function 
    // prop will be called when user enters email and password and clicks onSumbit on form itself.
    render() {

        /* Get the showAd directive from the AppConfig */
        let showAd = getAppConfigParm("showAd");

        return (
            <div> 
            {/* <div style={this.getPageContainerStyle()}> */}
                <Helmet>
                      <title>Log In to PitchIn Club</title>
                      <meta name="description" content="Pitch In Club Login Page" />
                </Helmet>
                <PageHeader />  
                {/* <PageHeader pageName="home" /> */}
                <VisibilityWrapper show={showAd} contentType="advertisement">
                  <div className="rc-flex-container-center-hv"  style={{borderTop: '1px solid #95A5A6'}}>
                      {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                      {displayAd("mobile-leader-board", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                      {displayAd("web-leader-board", "tablet", {marginTop: '1.3rem', marginBottom: '1.3rem'})}
                  </div>
                </VisibilityWrapper>  
                <div className="app-container-alt1">    
                    <div className="app-content-container"> 
                              {/* !showAd && <div className="rc-horiz-spacer-large">&nbsp;</div> */}
                            <div className="rc-horiz-spacer-large">&nbsp;</div>
                            <h3 className="form__title">Let's Start Pitching In</h3>
                            <h4 className="form__subtitle">The easy way to organize and have people "Pitch in"</h4>
                            <div>
                                <LoginForm 
                                onSubmit={this.onSubmit}
                                />  
                                <div className="rc-xlarge-mobile-gutter">&nbsp;</div>
                            </div>
                            <div className="rc-horiz-spacer-tiny"> </div> 
                            <div className="rc-xlarge-mobile-gutter">&nbsp;</div>
                      </div>
                </div> 
                <VisibilityWrapper show={showAd} contentType="advertisement" >
                  <div className="rc-flex-container-center-hv" style={{borderTop: '1px solid #BDC3C7'}}> 
                  {displayAd("web-leader-board", "desktop", {marginLeft: '0rem', marginTop: '1.3rem', marginBottom: '1.3rem'})}
                  {displayAd("", "mobile", {marginTop: '1rem', marginBottom: '1rem'})}
                  {displayAd("web-leader-board", "tablet", {marginTop: '1.5rem', marginBottom: '1.3rem'})}
                  </div> 
                </VisibilityWrapper>
                <Footer />
            </div>
        );
    };
};


// When using mapDispatchToProps you invoke function in your component as follows:
// this.props.startSignup(signupData) and not like this: this.props.dispatch(startSignup(signupData))
const mapDispatchToProps = (dispatch) => ({
    startLogin: (formData) => dispatch(startLogin(formData)),
    clearAuthError: () => dispatch(clearAuthError())
})

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);





// WEBPACK FOOTER //
// ./src/components/LoginPage.js